import React, {useState, useEffect} from 'react'
import { Carousel } from "react-responsive-carousel";
import {isMobile} from 'react-device-detect';
import TransformingSmilesSlideV2 from './TransformingSmilesSlideV2'
import IncreaseProductivitySlideV2 from './IncreaseProductivitySlideV2'
import SingleVisitSlider2 from './SingleVisitSlider2'
import KnowledgePortal2 from './KnowledgePortal2';

function MainBannerPro() {

  const slides = [  
    {
      component: <TransformingSmilesSlideV2 key='1'/>,
      id: '1'
    },
    {
      component: <IncreaseProductivitySlideV2 key='2'/>,
      id: '2'
    },
    {
      component: <KnowledgePortal2 key='3'/>,
      id: '3'
    },
    
    {
      component: <SingleVisitSlider2 key='4'/>,
      id: '4'
    },
  ]
  
  const indicatorHeight = (isMobile? 10 : 4)
  const indicatorWidth = (isMobile? 48 : 20)

  const indicatorStyle= {
    
    width: indicatorWidth,
    height: indicatorHeight,
    margin: '0 2px',
  };

  const [ activeSlide, setActiveSlide ] = useState(0);

  const [autoPlay, setAutoPlay] = useState(true);

  const nextSlide = () => {
    setActiveSlide(activeSlide+1);
  };

  useEffect(() => { 
    let t;
   
    function timerReset() {
       t= setTimeout(() => setActiveSlide(0), 10000)
    } 

    function timerNext() {
       t= setTimeout(nextSlide, 10000)
    }

    if(autoPlay){
      if(activeSlide===slides.length-1) {
        timerReset()
      } else {
        timerNext()
      }
    } 

    return() => {
      clearTimeout(t)
    }
    

  }, [activeSlide, autoPlay])

  return (
    <div className="relative">
      <Carousel swipeable={false} dynamicHeight={false} autoPlay={false} showIndicators={false} selectedItem={activeSlide} showStatus={false} showArrows={false} showThumbs={false}>
        {slides.map(slide => slide.component)}
       </Carousel>
       <ul className={`absolute bottom-8 inset-x-0 flex w-full flex-row ${isMobile? "justify-center gap-1" : "justify-center"}`}  onMouseEnter={()=>setAutoPlay(false)} onMouseLeave={()=>setAutoPlay(true)}>
          {slides.map((slide, index)=> {
            return (
              <li key={slide.id} className={`${activeSlide === index ? 'opacity-100 bg-primary' : 'opacity-30 bg-gray-500'}`} style={indicatorStyle} role="button" onClick={() => setActiveSlide(index)}></li>
              )
          })}
        </ul>
    </div>
  )
}

export default MainBannerPro;
